export default __webpack_public_path__ + "static/media/imprecision.318cacad.svg";